import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { ElectrificationStatus } from './electrification-status.enum';
import { SimulationTask } from '../simulation';
import { Organization } from '../organization';
import { PackageDealCalculated } from '../package-deal';

export class ElectrificationWizard extends BaseEntity {
	createdBy: string;

	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	@Type(() => SimulationTask)
	simulationTasks: SimulationTask[];

	@Type(() => PackageDealCalculated)
	packageDealsCalculated: PackageDealCalculated[];

	status: ElectrificationStatus;
	tcoPricePerMonth: number;
	leasingPerMonth: number;
	outDated: boolean;
	errorMessage: string;
	selectedPackageDealCalculatedId: string;
}
